import { Context, createWrapper } from "next-redux-wrapper";
import { applyMiddleware, combineReducers, createStore, Store } from "redux";
import ReduxThunk from "redux-thunk";
import chat, { ChatInitialStateProps } from "./chat/reducer";
import count from "./count/reducer";
import member, { MemberInitialStateProps } from "./member/reducer";
import promotions, { PromotionsInitialStateProps } from "./promotions/reducer";
import search, { SearchInitialStateProps } from "./search/reducer";
import tick from "./tick/reducer";
import ufabetGameModal, {
  UfabetGameModalInitialStateProps,
} from "./ufabetGameModal/reducer";

export interface AppReducerStateProps {
  count: any;
  tick: any;
  member: MemberInitialStateProps;
  chat: ChatInitialStateProps;
  search: SearchInitialStateProps;
  promotions: PromotionsInitialStateProps;
  ufabetGameModal: UfabetGameModalInitialStateProps;
}

const AppReducer = combineReducers({
  count,
  tick,
  member,
  chat,
  search,
  promotions,
  ufabetGameModal,
});

export const store = createStore(AppReducer, applyMiddleware(ReduxThunk));
const makeStore = (_context: Context) => store;
export const wrapper = createWrapper<Store<AppReducerStateProps>>(makeStore, {
  debug: true,
});
